import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Field } from '../../../environments/field';
import { environment } from '../../../environments/environment';
import { apis } from '../../../environments/apis';

// import { UserService } from '../../services/user.service';
import { CrudService } from '../../../environments/crud.service';
import { from } from 'rxjs';

// Aqui importa los formularios
// import * as forms from './forms/index';
// Notificaciones
// import { NotificationsService, NotificationType } from 'angular2-notifications';
// Tabla
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';

import * as forms from '../form/forms/index';

// Moneda en input
import { CommonModule, CurrencyPipe} from '@angular/common';

import {  } from '@tinymce/tinymce-angular'
import { view_seccion } from '../../../environments/seccions';
@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  providers: [CrudService, CurrencyPipe]
})
export class EditComponent implements OnInit {
  public initTiny = {
    language: 'es',
    height: 500,
    menubar: false,
    plugins: [
      'advlist autolink lists link image charmap print',
      'preview anchor searchreplace visualblocks code',
      'fullscreen insertdatetime media table paste',
      'help wordcount'
    ],
    toolbar:
      'undo redo | formatselect | bold italic | \
      alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | link image | fullscreen | help',
    image_title: true,
    images_upload_handler: this.example_image_upload_handler,
    images_upload_credentials: true,
    file_picker_types: 'image',
    
  }
  public token = sessionStorage.getItem("token");
  public tipo_de_area = sessionStorage.getItem("tipo_de_area");

  public data = {};
  public url = environment.apiUrl;
  // Secciones
  public listfields: Array<any>;
  public page_title: string;
  public page_description: string;
  public proyecto;
  public identity;
  public status;
  
  public create_edit;
  public id;
  public classwidthfields;
  public fields: Array<Field> = [];
  public fieldsexclude: Array<any> = [];

  public atras: string = "";
  public seccion: string;
  public view_seccion: string;
  public apisend: string;
  
  // Configuracion de tabla
  public idtable: string;
  public counttable: number = 0;
  public ColumnMode = ColumnMode;

  public exists_table: boolean = false;
  public exists_multiselect: boolean = false;

  public opciones;
  public currentActiveFroala: any;
  antecedentes = [
    "logotipo",
    "introduccion",
    "historia",
    "descripcion_de_la_empresa",
    "mision",
    "vision",
    "valores",
    "objetivos",
    "objetivos_especificos",
    "estrategias",
    "politicas",
    "eslogan",
    "descripcion_del_producto",
    "descripcion_del_servicio",
    "bibliografia",
    "instalaciones",
    "ubicacion_de_la_empresa",
    "producto_terminado",
  ]

  public datos;
  public tipo_de_proyecto = sessionStorage.getItem('tipo_de_proyecto')
  
  // private _userService: UserService,
  constructor(
    private route: ActivatedRoute,
    private _crudService: CrudService,
    private router: Router,
    // private notifications: NotificationsService,
    private currencyPipe : CurrencyPipe
  ) {
    this.proyecto = sessionStorage.getItem("proyecto");

    //------- Froala-------
    // this.opciones = {
    //   language: 'es',
    //   placeholderText: 'ingresa tu contenido aqui',
    //   // Set the image upload parameter.
    //   imageUploadParam: 'contenido',  
    //   // Set the image upload URL.
    //   imageUploadURL: environment.apiUrl+"api/v1/upload/",
    //   // Additional upload params.
    //   imageUploadParams: {
    //     seccion: 'froala', url:this.url
    //   },
    //   requestHeaders: {
    //     'Authorization':'Token '+this.token,
    //   },
    //   // Set request type.
    //   imageUploadMethod: 'POST',
    //   // Set max image size to 5MB.
    //   imageMaxSize: 5 * 1024 * 1024,
    //   // Allow to upload PNG and JPG.
    //   imageAllowedTypes: ['jpeg', 'jpg', 'png'],

    //   toolbarButtons: [
    //     'undo', 'redo' ,
    //     '|', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'outdent', 'indent', 'clearFormatting',
    //     '|', 'paragraphFormat', 'fontFamily', 'fontSize', 'orderedList', 'align', 'formatOL', 'formatUL',
    //     '|', 'insertImage', 'insertLink', 'insertTable',
    //     '|', 'specialCharacters', 'fullscreen', 'html',
    //   ],
    //   height: 300,
      
      
    // };

    // // Es el tamaño por defecto de los campos a los que no se les asigno un tamaño(width)
    // this.classwidthfields = "col-md-6";
    // // Son los tipos de campos que no son de tipo input pero existe un componente para ellos
    this.fieldsexclude = ["label", "richtext", "textarea", 'file', 'multiple_file', "select", "multiselect", "button", "table", "tags", "money", "number", "disabled"];

    


  }
  
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      
      // document.getElementById('el').reset;
      this.fields = [{
        type: "text",
        name: "string",
        value: "string",
        label: "string",
      }];
      this.seccion = params.seccion;
      this.view_seccion = view_seccion[this.seccion];
      if (this.seccion == 'amortizacion_gastos_instalacion'){
        this.atras = 'gastos_de_instalacion'
      }
      else if(this.seccion == 'amortizacion_gastos_organizacion'){
        this.atras = 'gastos_de_organizacion'

      }
      else if(this.seccion == 'prestaciones_produccion'){
        this.atras = 'recursos_humanos_produccion'

      }
      else if(this.seccion == 'prestaciones_ventas'){
        this.atras = 'recursos_humanos_ventas'

      }
      else if(this.seccion == 'prestaciones_administracion'){
        this.atras = 'recursos_humanos_administracion'

      }
      else if(this.seccion == 'depreciacion_edificios'){
        this.atras = 'edificios'

      }
      this.fields = forms[this.seccion];
      this.id = params.id;
      this.apisend = this.seccion
      if(this.antecedentes.includes(this.seccion)){
        this.apisend = "antecedentes"
      }
      this._crudService.getData(this.apisend, this.token, {proyecto:this.proyecto}).subscribe(
        response => {
          this.datos = response;
          for(let data in response){
            for(let field of this.fields){
              if(field.name == data){
                if(field.type == "richtext"){
                  field.value = response[data];
                  this.currentActiveFroala = response[data];
                  
                }
                else if (field.type == "file"){
                  this._crudService.getData("imagenes/"+response[data], this.token).subscribe(
                    data => {
                      field.value = data.imagen.substring(1, data.imagen.length);
                      
                    }
                  )
                  
                }
                else{
                    field.value = response[data];
                    if(field.type === "number" || field.type === "money"){
                      field.value = this.currencyPipe.transform(field.value, "").replace(/\$/g,"");              
                    }
                    
                }
                  

              }
            }
          }
        }
      )
    });
  }

  changeFroala(e){
    console.log(e)
    this.currentActiveFroala = e;
  }

  public initializeFroala(e, editor) {
    // alert()
    setTimeout(function(){
      e.initialize();
    }, 1*1000);
  }
  
  ifapi(seccion){
    let api = seccion
    if (seccion in apis){
      api = apis[seccion]
    }
    
    return api
  }

  onSubmit(form){
    let controls = form.controls;
    for(let control in form.controls){
      for(let field of this.fields){
        if(field.name == control && field.type == "richtext"){
          this.data[control] = controls[control].value
          this.datos[control]  = controls[control].value
        }
        else{
          this.data[control] = controls[control].value
          this.datos[control]  = controls[control].value

        }
      }
    }

    for(let field of this.fields){
      if(field.is_table){
        if(field.type == "table"){
          this.exists_table = true;
        }
      }
    }

    console.log(this.datos)
    // for(let data in this.data){
      this._crudService.putData(this.ifapi(this.apisend)+"/"+this.datos.id,this.token, this.datos).subscribe(
        response => {
          // this.notifications.success('¡Genial!', "Los datos han sido modificados correctamente", NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
        },
        error => {
          let alert = ""
          for(let e in error.error){
            alert += e+": "+error.error[e]+"<br>"
          }
          // swal.fire('¡Oops!', alert, 'warning');
          // this.notifications.warn('¡Oops!', alert, NotificationType.Bare, { theClass: 'outline primary', timeOut: 6000, showProgressBar: false });
      }
      )
    // }
    // this.data = {};
  }

  formChanged(i, validfield){
    this.fields[i].validfield = validfield;
  }

  onUploadError(event) {
    console.log(event);
  }

  onUploadSuccess(event) {
    console.log(event);
    let image = event[1].image;
    let name = event[1].name;
    let url = event[1].url;
    this.data[name] = image;
    this.datos[name] = image;
    // this.fields[name] = url;
    
    for(let data of this.fields) {
      if(data.name == name){
        data.value = url.substring(1, url.length);;
      }

    }

    console.log(event[1]);
    console.log(this.data);
  }

  onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
    );
  }

  addTable(cinpu, table){
    let fieldsAdd:any = document.getElementsByClassName(cinpu);
    for(let f of this.fields){

      if(f.type == "table"){

        if(f.classfield.includes(table)){
          let obj = {acciones:this.counttable}
          this.counttable += 1;
          for (let i = 0; i < fieldsAdd.length; i++) {

            let element = fieldsAdd[i];
            obj[element.getAttribute("ng-reflect-name").replace("_table","")] = element.value

            element.value = "";
            // console.log(element.getAttribute("ng-reflect-name"));

          }
          console.log(obj)
          f.rows.push(obj)
          f.rows = [... f.rows];


        }

      }
    }
  }

  removeByAttr(arr, attr, value){
    var i = arr.length;
    while(i--){
       if( arr[i]
           && arr[i].hasOwnProperty(attr)
           && (arguments.length > 2 && arr[i][attr] === value ) ){

           arr.splice(i,1);

       }
    }
    return arr;
  }

  // eliminar de Tabla
  // Eliminar
  removeTable(id, table) {
    this.idtable = id;
    for(let f of this.fields){

      if(f.type == "table"){

        if(f.classfield.includes(table)){
          this.removeByAttr(f.rows, "acciones", id)
          f.rows = [... f.rows];
        }
      }
    }
    console.log(this.idtable);
  }

  // Tags
  addTagFn(addedName) {
    return { name: addedName, tag: true };
  }

  // COnvertir a moneda
  transformAmount(element, name){
    console.log(Number(element.value));
    
    element.value = element.value.replace(/\$/g,"").replace(/\,/g,"")
    
    if(Number(element.value)){
      for(let field of this.fields){
        if(field.name == name){
          field.value = this.currencyPipe.transform(element.value, "");
          
        }
      }

    }
  }
  transformNumber(element, name){
    
    element.value = element.value.replace(/\$/g,"").replace(/\,/g,"")
    
    if(Number(element.value)){
      for(let field of this.fields){
        if(field.name == name){
          field.value = this.currencyPipe.transform(element.value, "").replace(/\$/g,"");
          
        }
      }

    }
  }
  
  example_image_upload_handler (blobInfo, success, failure, progress) {
    var xhr, formData;
  
    xhr = new XMLHttpRequest();
    xhr.withCredentials = true;
    xhr.open('POST', environment.apiUrl+"api/v1/upload/");
    xhr.setRequestHeader('Authorization', 'Token ' +sessionStorage.getItem("token"));
  
    xhr.upload.onprogress = function (e) {
      progress(e.loaded / e.total * 100);
    };
  
    xhr.onload = function() {
      var json;
  
      if (xhr.status === 403) {
        failure('HTTP Error: ' + xhr.status, { remove: true });
        return;
      }
  
      if (xhr.status < 200 || xhr.status >= 300) {
        failure('HTTP Error: ' + xhr.status);
        return;
      }
  
      json = JSON.parse(xhr.responseText);
  
      if (!json || typeof json.url != 'string') {
        failure('Invalid JSON: ' + xhr.responseText);
        return;
      }
  
      success(environment.apiUrl+json.url.substring(1, json.url.length));
    };
  
    xhr.onerror = function () {
      failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
    };
  
    formData = new FormData();
    formData.append('contenido', blobInfo.blob(), blobInfo.filename());
  
    xhr.send(formData);
  };
  
  
}
